import React from 'react';
import { Modal } from 'antd';

export default class MeetingModal extends React.Component {
  static defaultProps = {
    width: 400,
    loading: false,
    visible: false,
    onClose: null
  };
  render() {
    const { width, visible, content, onClose, title } = this.props;
    return (
      <Modal
        visible={visible}
        width={width}
        closable={false}
        maskClosable={false}
        footer={null}
        destroyOnClose
      >
        <div className="control-modal">
          <div className="meeting_modal_title">
            {title}
            <div onClick={onClose} className="cute_x">
              <i className="iconfont icon-x" />
            </div>
          </div>
          {content}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MeetingModal.js